import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaCheck, FaArrowRight, FaUsers, FaChartLine, FaRocket } from 'react-icons/fa';
import './DiventaInserzionistaPage.css';

const DiventaInserzionistaPage = () => {
  const [activeFaq, setActiveFaq] = useState(null);

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  const scrollToFaq = () => {
    const faqSection = document.getElementById('faq-section');
    if (faqSection) {
      faqSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <main className="diventa-inserzionista-page">
      {/* Hero Section - Layout a due colonne */}
      <section className="diventa-inserzionista-hero">
        <div className="main-content-container">
          <div className="diventa-inserzionista-hero-grid">
            <div className="diventa-inserzionista-hero-text">
              <h1 className="diventa-inserzionista-hero-title">
                Metti il turbo alle tue vendite
              </h1>
              <p className="diventa-inserzionista-hero-subtitle">
                Se stai sponsorizzando i tuoi prodotti su Google Shopping, ogni clic ti costa circa il <strong>20% in più</strong>. 
                Con Loverlist, comparatore + CSS partner, elimini quel sovrapprezzo e reinvesti il budget in crescita reale.
              </p>
              <div className="diventa-inserzionista-hero-cta">
                <Link to="/sign-up-seller" className="diventa-inserzionista-cta-btn">
                  Inizia subito
                  <FaArrowRight />
                </Link>
              </div>
            </div>
            <div className="diventa-inserzionista-hero-image">
              <div className="diventa-inserzionista-hero-visual">
                <div className="diventa-inserzionista-hero-chart">
                  <div className="diventa-inserzionista-chart-line diventa-inserzionista-chart-line-google">
                    <span className="diventa-inserzionista-chart-label">Google Shopping</span>
                    <div className="diventa-inserzionista-chart-bar diventa-inserzionista-chart-bar-google"></div>
                    <span className="diventa-inserzionista-chart-value">+20% CPC</span>
                  </div>
                  <div className="diventa-inserzionista-chart-line diventa-inserzionista-chart-line-loverlist">
                    <span className="diventa-inserzionista-chart-label">Loverlist CSS</span>
                    <div className="diventa-inserzionista-chart-bar diventa-inserzionista-chart-bar-loverlist"></div>
                    <span className="diventa-inserzionista-chart-value">0% markup</span>
                  </div>
                </div>
                <div className="diventa-inserzionista-hero-stats">
                  <div className="diventa-inserzionista-stat-item">
                    <FaRocket />
                    <span>Risparmio immediato</span>
                  </div>
                  <div className="diventa-inserzionista-stat-item">
                    <FaChartLine />
                    <span>ROI aumentato</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Comparatore + Traffico Section */}
      <section className="diventa-inserzionista-comparatore-section">
        <div className="main-content-container">
          <div className="diventa-inserzionista-comparatore-grid">
            <div className="diventa-inserzionista-comparatore-image">
              <div className="diventa-inserzionista-comparatore-visual">
                <div className="diventa-inserzionista-comparatore-mockup">
                  <div className="diventa-inserzionista-mockup-header">
                    <div className="diventa-inserzionista-mockup-dots">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                  <div className="diventa-inserzionista-mockup-content">
                    <div className="diventa-inserzionista-mockup-product">
                      <div className="diventa-inserzionista-mockup-product-image"></div>
                      <div className="diventa-inserzionista-mockup-product-info">
                        <div className="diventa-inserzionista-mockup-product-title"></div>
                        <div className="diventa-inserzionista-mockup-product-price"></div>
                      </div>
                    </div>
                    <div className="diventa-inserzionista-mockup-sellers">
                      <div className="diventa-inserzionista-mockup-seller">
                        <div className="diventa-inserzionista-mockup-seller-logo"></div>
                        <div className="diventa-inserzionista-mockup-seller-price"></div>
                      </div>
                      <div className="diventa-inserzionista-mockup-seller">
                        <div className="diventa-inserzionista-mockup-seller-logo"></div>
                        <div className="diventa-inserzionista-mockup-seller-price"></div>
                      </div>
                      <div className="diventa-inserzionista-mockup-seller">
                        <div className="diventa-inserzionista-mockup-seller-logo"></div>
                        <div className="diventa-inserzionista-mockup-seller-price"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="diventa-inserzionista-comparatore-stats">
                  <div className="diventa-inserzionista-stat-bubble">
                    <FaUsers />
                    <span>Milioni di visite</span>
                  </div>
                  <div className="diventa-inserzionista-stat-bubble">
                    <FaChartLine />
                    <span>Traffico qualificato</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="diventa-inserzionista-comparatore-text">
              <h2 className="diventa-inserzionista-comparatore-title">
                Il comparatore di prezzi che fa crescere il tuo business
              </h2>
              <p className="diventa-inserzionista-comparatore-description">
                Su Loverlist ottieni <strong>traffico diretto e qualificato</strong> dalle nostre milioni di visite giornaliere. 
                I nostri utenti sono alla ricerca dei migliori prodotti al miglior prezzo.
              </p>
              <div className="diventa-inserzionista-comparatore-benefits">
                <div className="diventa-inserzionista-comparatore-benefit">
                  <FaUsers />
                  <div>
                    <h4>Traffico qualificato</h4>
                    <p>Utenti che cercano prodotti specifici</p>
                  </div>
                </div>
                <div className="diventa-inserzionista-comparatore-benefit">
                  <FaChartLine />
                  <div>
                    <h4>Conversioni elevate</h4>
                    <p>Intento di acquisto già presente</p>
                  </div>
                </div>
                <div className="diventa-inserzionista-comparatore-benefit">
                  <FaRocket />
                  <div>
                    <h4>Visibilità immediata</h4>
                    <p>Appari nei risultati di confronto prezzi</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CSS Partner Section - Layout invertito */}
      <section className="diventa-inserzionista-css-section">
        <div className="main-content-container">
          <div className="diventa-inserzionista-css-grid">
            <div className="diventa-inserzionista-css-text">
              <h2 className="diventa-inserzionista-css-title">
                Il tuo nuovo CSS Partner: <span className="whitespace-nowrap">–20% CPC</span> immediato
              </h2>
              
              <div className="diventa-inserzionista-css-text-content">
                <p>
                  Ottieni più visibilità con le tue campagne Google Shopping usando Loverlist come CSS. Google applica un markup ai clic di Shopping per i merchant che non passano da un Comparison Shopping Service.
                  Il risultato? <strong>Paghi circa un quinto in più</strong> per lo stesso traffico.
                </p>
                <p>
                  Con Loverlist il tuo feed viene veicolato dal nostro CSS certificato: il markup scompare, il costo-per-clic scende e il tuo ROAS aumenta.
                </p>
                <p>
                  Usa il budget che risparmi per spingere categorie strategiche o lanciare nuovi prodotti.
                </p>
              </div>

              <div className="diventa-inserzionista-css-cta">
                <button onClick={scrollToFaq} className="diventa-inserzionista-calc-btn">
                  Scopri di più
                </button>
              </div>

              {/* Micro-story callout */}
              <div className="diventa-inserzionista-callout">
                <em>
                  "Con 2.000 clic al mese il tuo negozio spende circa <s>400 €</s> extra senza nemmeno saperlo. 
                  Passando a Loverlist quei 400 € tornano nel tuo wallet, pronti a generare nuove vendite."
                </em>
              </div>
            </div>
            <div className="diventa-inserzionista-css-image">
              <div className="diventa-inserzionista-css-visual">
                <div className="diventa-inserzionista-css-certification">
                  <div className="diventa-inserzionista-certification-badge">
                    <div className="diventa-inserzionista-badge-icon">✓</div>
                    <span>CSS Certificato</span>
                  </div>
                  <div className="diventa-inserzionista-certification-stats">
                    <div className="diventa-inserzionista-cert-stat">
                      <div className="diventa-inserzionista-cert-stat-number">-20%</div>
                      <div className="diventa-inserzionista-cert-stat-label">CPC</div>
                    </div>
                    <div className="diventa-inserzionista-cert-stat">
                      <div className="diventa-inserzionista-cert-stat-number">0%</div>
                      <div className="diventa-inserzionista-cert-stat-label">Markup</div>
                    </div>
                    <div className="diventa-inserzionista-cert-stat">
                      <div className="diventa-inserzionista-cert-stat-number">+25%</div>
                      <div className="diventa-inserzionista-cert-stat-label">ROI</div>
                    </div>
                  </div>
                </div>
                <div className="diventa-inserzionista-css-process">
                  <div className="diventa-inserzionista-process-step">
                    <div className="diventa-inserzionista-step-number">1</div>
                    <span>Feed integrato</span>
                  </div>
                  <div className="diventa-inserzionista-process-arrow">→</div>
                  <div className="diventa-inserzionista-process-step">
                    <div className="diventa-inserzionista-step-number">2</div>
                    <span>CSS certificato</span>
                  </div>
                  <div className="diventa-inserzionista-process-arrow">→</div>
                  <div className="diventa-inserzionista-process-step">
                    <div className="diventa-inserzionista-step-number">3</div>
                    <span>Risparmio immediato</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq-section" className="diventa-inserzionista-faq-section">
        <div className="main-content-container">
          <h2 className="diventa-inserzionista-faq-title">Domande frequenti</h2>
          
          <div className="diventa-inserzionista-faq-list">
            <div className="diventa-inserzionista-faq-item">
              <button 
                className="diventa-inserzionista-faq-question"
                onClick={() => toggleFaq(0)}
              >
                Perché dovrei usare Loverlist se già faccio Shopping da solo?
                <span className="diventa-inserzionista-faq-icon">
                  {activeFaq === 0 ? '−' : '+'}
                </span>
              </button>
              {activeFaq === 0 && (
                <div className="diventa-inserzionista-faq-answer">
                  Oggi paghi un sovrapprezzo ~20% su ogni clic per le tue campagne Google Shopping. Loverlist è CSS partner: il markup scompare, 
                  ottieni più traffico a parità di budget (o lo stesso traffico spendendo meno).
                </div>
              )}
            </div>

            <div className="diventa-inserzionista-faq-item">
              <button 
                className="diventa-inserzionista-faq-question"
                onClick={() => toggleFaq(1)}
              >
                Come funziona l'integrazione con il mio e-commerce?
                <span className="diventa-inserzionista-faq-icon">
                  {activeFaq === 1 ? '−' : '+'}
                </span>
              </button>
              {activeFaq === 1 && (
                <div className="diventa-inserzionista-faq-answer">
                  L'integrazione è semplice e veloce. Supportiamo Shopify, WooCommerce, PrestaShop, Magento 2 e feed csv personalizzati. 
                  Il nostro team ti guida passo dopo passo nell'implementazione.
                </div>
              )}
            </div>

            <div className="diventa-inserzionista-faq-item">
              <button 
                className="diventa-inserzionista-faq-question"
                onClick={() => toggleFaq(2)}
              >
                Quanto tempo ci vuole per vedere i primi risultati?
                <span className="diventa-inserzionista-faq-icon">
                  {activeFaq === 2 ? '−' : '+'}
                </span>
              </button>
              {activeFaq === 2 && (
                <div className="diventa-inserzionista-faq-answer">
                  I primi risultati si vedono immediatamente: il risparmio del 20% sui CPC è istantaneo. 
                  Per l'ottimizzazione completa delle campagne consigliamo 2-4 settimane di monitoraggio.
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final Section */}
      <section className="diventa-inserzionista-cta-section">
        <div className="main-content-container">
          <div className="diventa-inserzionista-cta-content">
            <h2 className="diventa-inserzionista-cta-title">
              Pronto a recuperare quel 20% che stai regalando a Google?
            </h2>
            
            <div className="diventa-inserzionista-benefits">
              <div className="diventa-inserzionista-benefit">
                <FaCheck />
                <span>Stop al surcharge Google: –20% CPC da subito</span>
              </div>
              <div className="diventa-inserzionista-benefit">
                <FaCheck />
                <span>Nessuna fee di listing</span>
              </div>
              <div className="diventa-inserzionista-benefit">
                <FaCheck />
                <span>Wallet ricaricabile</span>
              </div>
            </div>

            <div className="diventa-inserzionista-cta-buttons">
              <Link to="/sign-up-seller" className="diventa-inserzionista-primary-btn">
                Iscrivi il tuo e-commerce
              </Link>
              <Link to="/contatti" className="diventa-inserzionista-secondary-btn">
                Parlaci del tuo business
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default DiventaInserzionistaPage; 